import { render } from "./ChartB.vue?vue&type=template&id=3bbe8bb8&scoped=true"
import script from "./ChartB.vue?vue&type=script&lang=ts"
export * from "./ChartB.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3bbe8bb8"

export default script